import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { MailCheck } from "lucide-react";

// Iteration 21 — the link-based verification flow was retired. Any old
// bookmarks landing on /verify-email?token=… are redirected to the in-app
// 6-digit code screen, which lives on the onboarding page for players and on
// the streamer onboarding page for streamers.
export default function VerifyEmail() {
  return (
    <div className="max-w-lg mx-auto px-6 py-24">
      <div className="border border-[#F5B841]/40 bg-[#F5B841]/5 p-10" data-testid="verify-link-retired">
        <MailCheck className="w-10 h-10 text-[#F5B841] mb-4" />
        <h1 className="font-display text-3xl font-black tracking-tighter mb-3">We use a 6-digit code now</h1>
        <p className="text-sm text-[#8B97AE] mb-6">
          The email-link flow was replaced. Please log in and enter the 6-digit code from your inbox on the confirmation screen.
        </p>
        <div className="flex gap-3">
          <Button asChild className="rounded-none bg-[#2DD4A7] text-[#04150F] hover:bg-[#F5B841] hover:text-[#04150F] h-11 px-5 font-semibold transition-colors">
            <Link to="/login" data-testid="verify-goto-login">Log in</Link>
          </Button>
          <Button asChild variant="ghost" className="rounded-none border border-white/20 h-11 px-5 font-semibold text-white hover:bg-white/10 transition-colors">
            <Link to="/">Home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
